import React from "react";
import Comentarios from "../../components/1.4 comentarios/comentarios";

const HomePage = () => {
  return (
    <div className="capsule" style={{ padding: "5px 0 0 0" }}>
      <Comentarios />
    </div>
  );
};

export default HomePage;
